import { memo, useState, useEffect } from 'react';
import { Dialog } from '@material-ui/core';

type Props = {
	isOpen: boolean;
	doTrans: Function;
	buttonLabel?: string;
	dialogType?: CompleteDialogType;
	element?: JSX.Element;
};
export const DialogType = {
	UPDATED: { image: 'img-update.svg', imageAlt: '更新されました!' },
	REGISTERED: { image: 'img-registered.svg', imageAlt: '登録が完了しました！' },
	COMPLETED: { image: 'img-complete.svg', imageAlt: '完了しました' },
} as const;
type CompleteDialogType = typeof DialogType[keyof typeof DialogType];

export const CompleteDialog = memo((props: Props) => {
	const { isOpen, doTrans, buttonLabel = 'マイページTOP', dialogType = DialogType.UPDATED, element } = props;
	const [open, setOpen] = useState(false);
	const [timer, setTimer] = useState(undefined);
	const clearTimer = () => {
		clearTimeout(timer);
	};

	useEffect(() => {
		setOpen(isOpen);
	}, [isOpen]);

	useEffect(() => {
		if (open) {
			const timer = setTimeout(function () {
				doTrans();
			}, 5000);
			setTimer(timer);
		}
	}, [open]);

	return (
		<>
			<Dialog open={open}>
				<div className="popup-wrap">
					<div className="popup-in">
						<div className="update-box">
							<img src={`images/${dialogType.image}`} alt={dialogType.imageAlt} />
						</div>
						{element ? element : <p>{`5秒後に自動的に${buttonLabel}へ戻ります`}</p>}
						<div className="btn-box">
							<div className="btn gr">
								<button
									onClick={() => {
										clearTimer();
										doTrans();
									}}
								>{`${buttonLabel}へ戻る`}</button>
							</div>
						</div>
					</div>
				</div>
			</Dialog>
		</>
	);
});
